import { render, staticRenderFns } from "./split_package.vue?vue&type=template&id=38ef3b66&"
import script from "./split_package.vue?vue&type=script&lang=js&"
export * from "./split_package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports